import React, { useMemo } from 'react';
import { Select } from 'antd';
import useTranslation from '../../../../hooks/useTranslation';
import { dataToSelectConvertor, enumToDropDown } from '../../../../core/helpers/dropdownDataConverter';
import FormItem from '../formItem';
import T from '../../../../core/translations/translations.json';

const { Option } = Select;

const MultipleSelect = ({
							name,
							label,
							values,
							loading,
							onChange,
							placeholder,
							data = [],
							width = 250,
							valueKey = 'id',
							labelKey = 'name',
							allowClear = false,
							dataIsEnum = false,
							optionFilterProp = 'children',
							...restProps
						}) => {
	const translate = useTranslation();

	const optionData = useMemo(() => {
		let result = [];
		if(dataIsEnum) {
			result = enumToDropDown(data);
		} else {
			result = dataToSelectConvertor(data, { labelKey, valueKey });
		}

		return result;
	}, [ data ]);

	return (
		<Select
			name={name}
			showSearch
			mode="multiple"
			loading={loading}
			style={{ width }}
			onChange={onChange}
			allowClear={allowClear}
			className="ant_des_select"
			optionFilterProp={optionFilterProp}
			placeholder={translate(placeholder)}
			{...restProps}
		>
			{
				optionData.map((item) => (
					<React.Fragment key={item.value}>
						<Option key={item.value}>{item.label}</Option>
					</React.Fragment>
				))
			}
		</Select>
	);
};

export default MultipleSelect;